module.exports = __webpack_public_path__ + "static/logo-f7e432caee83949424e8d72381b43fac.png";